import { useQuery } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { whenAuthenticated } from '@/utils/query-utils'

export const useTransformersPortfolioStatusSummaryQuery = () => {
    return useQuery({
        queryKey: ['transformers', 'portfolioOverview', 'statusSummary'],
        queryFn: async ({ signal }) => {
            const {
                data: { result },
            } = await hcaClientFactory.portfolioOverviewApi.getTransformerPortfolioSummary(
                {},
                {
                    signal,
                },
            )
            return result
        },
        enabled: whenAuthenticated,
    })
}
